import { GetStaticPropsContext } from "next";
import { NextSeo } from "next-seo";
import { BlogContent } from "~/components/blog";
import { Layout } from "~/components/common";
import { BlogDataType, BlogPostProps } from "~/types";

export default function Blog({
  articles,
  totalPosts,
  totalPages,
}: Readonly<BlogPostProps>) {
  return (
    <>
      <NextSeo
        title="Blog | Tucker Tub"
        description="Tucker Tub's Blogs"
        openGraph={{
          title: "Blog | Tucker Tub",
          description: "Tucker Tub's Blog",
          url: process.env.NEXT_PUBLIC_FRONTEND_URL,
          type: "website",
          locale: "en_AU",
          site_name: "Tucker Tub",
        }}
      />
      <Layout>
        <BlogContent
          articles={articles}
          totalPages={totalPages}
          totalPosts={totalPosts}
        />
      </Layout>
    </>
  );
}

export async function getStaticProps(context: GetStaticPropsContext) {
  try {
    const endpoint = process.env.WORDPRESS_ENDPOINT;
    const response = await fetch(
      `${endpoint}/wp-json/wp/v2/blogposts/?page=1&per_page=10&_embed`
    );
    const totalPosts = response.headers.get("x-wp-total");
    const totalPages = response.headers.get("x-wp-totalpages");
    const data = await response.json();

    const blogsData = data.map((d: BlogDataType) => ({
      title: d.acf.title,
      image: d.acf.image,
      content: d.acf.content,
      slug: d.slug,
      id: d.id,
    }));

    return {
      props: {
        articles: blogsData,
        totalPages,
        totalPosts,
      },
      revalidate: 60,
    };
  } catch (error) {
    console.error("Error fetching post:", error);
    return {
      notFound: true,
    };
  }
}
